import { TOGGLE_MENU_COLLAPSED } from 'secured/constants';

export const toggleMenuCollapsed = (menu, collapsed) => ({
  type: TOGGLE_MENU_COLLAPSED,
  payload: { menu, collapsed },
});



// WEBPACK FOOTER //
// src/modules/secured/actions/secured_actions.js